//电话号码登录
import React from 'react';
import ReactDOM from 'react-dom';
import config from '../../../assets/js/conf/config.js';
import {request} from '../../../assets/js/libs/request.js';
import { Switch,Toast } from 'antd-mobile';
import '../../../assets/css/common/reg/index.css';
import {connect} from 'react-redux';

export default class RegIndex extends React.Component{
    constructor(){
        super();
        this.state={
            checked:false,
            sCellphone:'',
            sCode: '',
            bCodeSuccess:false,
            sCodeText:'获取验证码',
            sType:"password",
            telInput: false,
            textInput: false
        };
        
        this.timer=null;
        this.bSendCode=true;
        this.bSubmit=true;
    }
    componentDidMount(){
		// window.addEventListener("scroll",  function(){
		// 	console.log(1)
		// },false);
	}
    componentWillUnmount(){
        clearInterval(this.timer);
        this.setState=(state,callback)=>{
            return;
        }
    }
    //验证手机号
    checkCellphone(e){
        this.setState({sCellphone:e.target.value},()=>{
            if (this.bSendCode){
                if(this.state.sCellphone.match(/^1[0-9][0-9]{9}/)){
                    this.setState({bCodeSuccess:true});
                }else{
                    this.setState({bCodeSuccess:false});
                }
            }
        })
    }
    //点击获取短信验证码
    async getCode(){
    	let that = this;
    	if(this.state.sCellphone.match(/^\s*$/)){
            Toast.info("请输入您的手机号",2);
            return false;
        }
    	
        if (this.bSendCode && this.state.bCodeSuccess){
//          let resData = await this.isSameCellphone();
//			//console.log(resData)
//          if (resData.data === 0){
//              //Toast.info("您输入的账号已存在，将直接登录！",1);
//              setTimeout(function(){
//					that.submit(true);
//				}, 500);
//				
//              return false;
//          }else{
            	this.isphone();
//            }
            this.bSendCode=false;
            let iTime = 60;
            this.setState({sCodeText:+iTime+'s',bCodeSuccess:false});
            this.timer = setInterval(()=>{
                if (iTime>0){
                    iTime--;
                    this.setState({sCodeText:iTime+'s'});
                }else{
                    clearInterval(this.timer);
                    this.bSendCode=true;
                    this.setState({sCodeText:'获取验证码'});
                    this.setState({bCodeSuccess:true});
                }
            },1000);
        }
    }
    //点击注册按钮提交数据
    async submitData(){
        if(this.state.sCellphone.match(/^\s*$/)){
            Toast.info("请输入您的手机号",2);
            return false;
        }
        if(!this.state.sCellphone.match(/^1[0-9][0-9]{9}/)){
            Toast.info("您输入的手机号格式不正确",2);
            return false;
        }
        if(this.state.sCode === ''){
            Toast.info("请输入验证码",2);
            return false;
        }
        this.submit(false);
    }
    //提交数据
    submit(flag){
    	let that = this;
    	if (this.bSubmit){
            this.bSubmit=false;
            let data = {
				  "client": 4,
				  "phone": this.state.sCellphone,
				  "code": this.state.sCode
				}
            let sUrl=config.baseUrl+"api/Study/S018";
			this.bSubmit = true;
            request(sUrl, "post", data).then(res=>{
				Toast.info(res.message,1);
				//console.log(res.data)
				if (res.code === 0){
					localStorage['phone'] = this.state.sCellphone;
					localStorage['LoginData'] = JSON.stringify(res.data);
					
					if(res.data.isRegister == 0){
						that.props.history.replace('/login');
					}else{
						setTimeout(function(){
							that.props.history.replace('/home/index');
						}, 1500);
					}
				}
	        });
       }
    }
    //显示密码是明码还是暗码
    changePwd(checked) {
        if (checked){
            this.setState({sType:"text"});
        }else{
            this.setState({sType:"password"});
        }
        this.setState({checked: checked});
    }
    //检测手机号是否注册过
    isSameCellphone(){
        let sUrl= config.baseUrl+"api/Study/S015";
        return request(sUrl, "post", {openId:this.state.openId,accessToken:this.state.AccessToken}).then(res=>{
            return res;
        });
    }
    //发送手机验证码
    isphone(){
        let sUrl= config.baseUrl+"api/Study/S003";
        return request(sUrl, "post", {phone:this.state.sCellphone}).then(res=>{
            return res;
        });
    }
    //焦点事件
    inputOnFocus(flag){
    	if(flag == 'tel'){
    		this.setState({
	    		telInput: true
	    	})
    	}else{
    		this.setState({
	    		textInput: true
	    	})
    	}
    }
    inputOnBlur(flag){
    	if(flag == 'tel'){
    		this.setState({
	    		telInput: false
	    	})
    	}else{
    		this.setState({
	    		textInput: false
	    	})
    	}
    }
	ZhuCeClick(){
		//this.props.history.replace('/RegIndex/index');
		let WXurl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2ac90c6545e0135e&redirect_uri=http://ptt.zlgxt.cn/h5/index.html&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect";
		window.location.href = WXurl;
	}
    render(){
        return (
            <div className={'page'}>
                <div className={'main'}>
                	<div class='OneMess'>
                		您好，<br />
                		欢迎来到PTT养猪学院
                	</div>
                    <div className={'cellphone-wrap'}>
                    	<div class='Onetext'>手机号码</div>
                        <div className={this.state.telInput?'cellphone cellphone_color':'cellphone'}>
                        	<input type="tel" placeholder="请输入手机号" 
                        		onChange={(e)=>{this.checkCellphone(e)}}
                        		onBlur={this.inputOnBlur.bind(this, 'tel')}
       							onFocus={this.inputOnFocus.bind(this, 'tel')}
                        	/>
                        </div>
                        {
//                      	<div className={this.state.bCodeSuccess?'OneError Onetext hide':'OneError Onetext'}>手机号错误</div>
                        }
                    </div>
                    <div className={'code-wrap'}>
                    	<div class='Onetext'>验证码</div>
                    	<div className={this.state.textInput?'code-wrap-cont cellphone_color':'code-wrap-cont'}>
                    		<input type="tel" placeholder="请输入短信验证码" 
                    			onChange={(e)=>{this.setState({sCode:e.target.value})}} 
                    			onBlur={this.inputOnBlur.bind(this, 'text')}
       							onFocus={this.inputOnFocus.bind(this, 'text')}
                    		/>
                    		<div className={'code-btn'} onClick={this.getCode.bind(this)}>
                    			{this.state.sCodeText}
                    		</div>
                    	</div>
                    	{
//                  		<div class='OneError Onetext'>验证码错误</div>
                    	}
                    </div>
                    <div className={'sure-btn'} onClick={this.submitData.bind(this)}>登录</div>
					<div className={'zc'} onClick={this.ZhuCeClick.bind(this)}>返回注册</div>
                </div>
            </div>
        )
    }
}